module.exports = __webpack_public_path__ + "img/pr.5d31dcaf.svg";